/**
 * SliderControls component.
 */
import PaginationDots from '@components/elements/pagination/paginationDots';
import SliderPressableContainer from '@components/atoms/container/sliderPressableContainer';
import type { PaginationDotsProps } from '@components/elements/pagination/paginationDots';
import { DELAY } from '../../../../shared/types/constants/animations';
import SliderArrows, {
  SliderArrowsProps,
} from '@components/elements/sliders/sliderArrows';

/**
 * Props for the SliderControls component.
 */
export interface Props {
  arrows: SliderArrowsProps;
  controls: {
    onClick?: () => void;
    onMouseEnter?: () => void;
  };
  dots: PaginationDotsProps;
}

/**
 * Renders the SliderControls component.
 * @param arrows - The props for the SliderArrows component.
 * @param controls - The props for the SliderControls component.
 * @param dots - The props for the PaginationDots component.
 * @returns The SliderControls component.
 */
export default function SliderControls({ controls, arrows, dots }: Props) {
  return (
    <>
      <SliderArrows {...arrows} />
      <SliderPressableContainer
        {...controls}
        delay={DELAY.SLIDER_PRESSABLE_CONTAINER}
      >
        <PaginationDots {...dots} />
      </SliderPressableContainer>
    </>
  );
}
